import styled from '@emotion/styled';

import CONST from '../constants';
import { Container, Body, Title } from './Common';
import imgBody from '../resources/overview-1.jpg';
import imgLocationMap from '../resources/overview-map.png';
import imgNaverIcon from '../resources/naver-icon.png';
import React from 'react';

const BREAKPOINT_LIMIT = CONST.SCREEN.BREAKPOINT.XL;

const Business = {
    Image: styled.img`
        width: 100%;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            width: 90%;
            border-radius: 0.25vw;
            box-shadow: 0 5px 10px ${CONST.COLOR.BG};
        }
    `,
    Description: styled.div`
        position: relative;
        width: 90%;
        margin: 0 auto;
        padding: 1vw 5vw 4vw;
        background: white;
        border: 1px solid rgba(9, 31, 44, 0.25);
        border-radius: 5px;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            width: 70%;
            margin: 0 auto;
            padding: 1vw 2vw 4vw;
        }

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.XL}px) {
            margin: 0 auto;
            padding: ${CONST.SCREEN.BREAKPOINT.XL * 0.01}px ${CONST.SCREEN.BREAKPOINT.XL * 0.02}px ${CONST.SCREEN.BREAKPOINT.XL * 0.04}px;
        }

        & p.desc-title {
            display: block;
            margin: 0;
            color: ${CONST.COLOR.THEME};
            font-size: 3vw;
            font-weight: bold;
            line-height: 2;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 2.5vw;
            }

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.XL}px) {
                font-size: 20px;
            }
        }

        & .desc-row {
            display: flex;
            border-top: 1px solid ${CONST.COLOR.THEME}3F;

            &:first-of-type {
                border-top: 2px solid ${CONST.COLOR.THEME}CC;
            }
            &:last-of-type {
                border-bottom: 1px solid ${CONST.COLOR.THEME}3F;
            }
        }

        & .desc-col {
            display: inline-block;
            padding: 1vw 0;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                padding: 10px 0;
            }

            &:first-of-type {
                flex: 0 0 auto;
                width: 25%;
                background: ${CONST.COLOR.CREAM}3F;
                text-align: center;
            }
            &:last-of-type {
                padding-left: 2vw;
                width: 75%;
                border-left: 1px solid rgba(9, 31, 44, 0.25);
                text-align: left;

                @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                    padding-left: 20px;
                }
            }
        }

        & .area-row {
            display: flex;
            border-top: 1px solid ${CONST.COLOR.THEME}3F;

            &:first-of-type {
                border-top: 2px solid ${CONST.COLOR.THEME}CC;
                background: ${CONST.COLOR.THEME_SECONDARY}3F;
            }
            &:last-of-type {
                border-bottom: 1px solid ${CONST.COLOR.THEME}3F;
            }
        }

        & .area-col {
            display: inline-block;
            padding: 1vw 0;
            border-right: 1px solid ${CONST.COLOR.THEME}3F;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                padding: 10px 0;
            }

            &:last-of-type {
                border-right: none;
            }
        }

        & p {
            margin: 0;
            color: ${CONST.COLOR.THEME};
            font-size: 2.3vw;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 1.5vw;
            }

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.XL}px) {
                font-size: 15px;
            }
        }
    `,
};

const Location = {
    Image: styled.img`
        width: 80%;
        max-width: 500px;
        border: 0.75vw double ${CONST.COLOR.THEME_DARK};

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            border: 0.5vw double ${CONST.COLOR.THEME_DARK};
            border-radius: 0.5vw;
            box-shadow: 0 0.25vw 0.5vw ${CONST.COLOR.TEXT};
        }

        @media screen and (min-width: ${BREAKPOINT_LIMIT}px) {
            border: ${BREAKPOINT_LIMIT * 0.005}px double ${CONST.COLOR.THEME_DARK};
            border-radius: ${BREAKPOINT_LIMIT * 0.005}px;
            box-shadow: 0 ${BREAKPOINT_LIMIT * 0.0025}px ${BREAKPOINT_LIMIT * 0.005}px ${CONST.COLOR.TEXT};
        }
    `,
    Text: styled.p`
        margin: 0;
        color: ${CONST.COLOR.TEXT};
        font-size: 4.5vw;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            font-size: 20px;
        }

        & > span {
            display: block;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                display: inline;
            }
        }
    `,
    Button: styled.a`
        display: inline-block;
        padding-right: 3vw;
        background: #03c75a;
        color: white;
        border-radius: 1vw;
        box-shadow: 0 0 1vw ${CONST.COLOR.THEME_SECONDARY};
        text-decoration: none;

        &:hover {
            color: white;
            opacity: 0.75;
            transition: opacity 300ms ease;
        }

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            padding-right: 18px;
            border-radius: 5px;
            box-shadow: 0 0 5px ${CONST.COLOR.THEME_SECONDARY};
        }

        & > img {
            height: 10vw;
            max-height: 200px;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                height: 50px;
            }
        }

        & > p {
            display: inline-block;
            margin: 0;
            font-size: 3.5vw;
            font-weight: bold;
            vertical-align: middle;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 15px;
            }
        }
    `,
};

const Overview = () => {
    const descriptionData = [
        { title: '대지위치', text: '서울시 구로구 고척동 85-15 번지 외 9필지' },
        { title: '대지면적', text: '4,140.00m² [1,252.35평], 실사용 [1,086.88평]' },
        { title: '연면적', text: '27,768.97m² [8,400.11평]' },
        { title: '전용률', text: '47.50%' },
        { title: '호실수', text: '지식산업센터(219실), 근린생활시설(18실)' },
        { title: '건축규모', text: '지하 1층 ~ 지상 18층' },
        { title: '주차대수', text: '총 196대(법정대비 190.29%)' },
    ];
    const descriptionFragment = [];
    for (const description of descriptionData) {
        descriptionFragment.push(
            <React.Fragment>
                <div className="desc-row" key={description.title}>
                    <div className="desc-col">
                        <p>{description.title}</p>
                    </div>
                    <div className="desc-col">
                        <p>{description.text}</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    /*const areaData = [
        ['구분', '전용면적(평)', '분양면적(평)', '비율'],
        ['공장', '3,654.17', '7,693.66', '91.59%'],
        ['근린생활시설', '335.55', '706.46', '8.41%'],
        ['합계', '3,989.71', '8,400.11', '100%']
    ];
    const areaFragment = [];
    for (const area of areaData) {
        areaFragment.push(
            <React.Fragment>
                <div className='area-row' key={area[0]}>
                    <div className='area-col col-3'>
                        <p>{area[0]}</p>
                    </div>
                    <div className='area-col col-3'>
                        <p>{area[1]}</p>
                    </div>
                    <div className='area-col col-3'>
                        <p>{area[2]}</p>
                    </div>
                    <div className='area-col col-3'>
                        <p>{area[3]}</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }*/

    return (
        <Container>
            <Title textKr="사업개요" textEng="Business Overview" />
            <Body>
                <Business.Image src={imgBody} alt="" />
                <Business.Description className="mt-2">
                    <p className="desc-title">건축개요</p>
                    {descriptionFragment}
                </Business.Description>
            </Body>
            <Title textKr="위치" textEng="Location" />
            <Body className="mt-3 mt-sm-4">
                <Location.Image src={imgLocationMap} alt="" />
                <Location.Text className="mt-3 mt-sm-4">서울시 구로구 고척동 85-15 번지 외 9필지</Location.Text>
                <Location.Button className="mt-3 mt-sm-4" href="https://naver.me/FfWl8a26" target="_blank" rel="noreferrer">
                    <img src={imgNaverIcon} alt="" />
                    <p>네이버지도 바로가기</p>
                </Location.Button>
            </Body>
        </Container>
    );
};

export default Overview;
